/**
 * Shared application steps config.
 * Import this in every page header + StepHeader.
 */
export const APP_STEPS = [
  { label: "Personal Information",  short: "Personal",  path: "/application/personal-information" },
  { label: "Academic Details",      short: "Academic",  path: "/application/academic-information" },
  { label: "Financial Details",     short: "Financial", path: "/application/finance-details" },
  { label: "Upload Documents",      short: "Documents", path: "/application/upload-documents" },
  { label: "Personal Statement",    short: "Statement",  path: "/application/personal-statement" },
  { label: "Review & submit",       short: "Review",    path: "/application/review" },
];

/** Helper: get step index from current path */
export const getStepIndex = (pathname) =>
  APP_STEPS.findIndex((s) => s.path === pathname);
